<template>
  <div>
    <v-card class="mx-auto mb-6" outlined>
      <v-list-item three-line>
        <v-list-item-content>
          <div class="overline mb-4">{{ test.subject.name }} - {{ test.subject.room.sections }}</div>
          <v-list-item-title class="headline mb-1">{{ test.tname }}</v-list-item-title>
          <v-list-item-subtitle class="mb-1">
            <b>{{ test.description }}</b>
          </v-list-item-subtitle>
          <v-list-item-subtitle>{{ startDateTime }} - {{ endDateTime }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-card-actions>
        <div v-if="currentUser.is_faculty">
          <div v-if="!isUpcoming">
            <v-btn text :to="`/test/${this.test.id}/stats`" color="primary">View Stats</v-btn>
            <v-btn text :to="`/test/edit/${this.test.id}`" color="primary">View Questions</v-btn>
          </div>
          <div v-else>
            <v-btn text :to="`/test/edit/${this.test.id}`" color="primary">Edit Test</v-btn>
            <v-dialog v-model="editDialog" max-width="600px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  text
                  @click="editDialog = true"
                  v-if="isUpcoming && (currentUser.is_admin || test.created_by.id == currentUser.id)"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                >Edit Details</v-btn>
              </template>
              <AddTest
                @closeAddTestDialog="editDialog=false"
                @refreshList="$emit('refreshList')"
                class="add-test"
                :editId="test.id"
                :isEditing="true"
                v-if="currentUser.is_faculty"
              />
            </v-dialog>

            <v-btn text @click="showDeleteConfirmation" color="red">Delete Test</v-btn>
          </div>
        </div>
        <div v-if="currentUser.is_student">
          <v-btn :to="`/test/${test.id}`" v-if="isOngoing" text>Give Test</v-btn>
          <v-btn :to="`/test/${test.id}`" v-else text>View Details</v-btn>
        </div>
      </v-card-actions>
    </v-card>
    <DeleteConfirmationBox
      title="Are you sure you want to delete this test?"
      description="Deleting this test will remove all the questions and other data associated with this test."
      :visible="deleteDialogVisible"
      @deleteObject="deleteTest"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import DeleteConfirmationBox from "../../components/widgets/DeleteConfirmationBox";
import AddTest from '@components/tests/AddTest';

export default {
  name: "TestListItem",
  props: ["test"],
  components: {
    DeleteConfirmationBox,
    AddTest
  },
  data() {
    return {
      editDialog: false,
      deleteDialogVisible: false,
    };
  },

  methods: {
    showDeleteConfirmation() {
      this.deleteDialogVisible = true;
    },
    // if confirm, emits to testlist for deleting test
    deleteTest(confirm) {
      if (!confirm) this.deleteDialogVisible = false;
      else this.$emit("deleteTest", this.test);
    },
    refreshItem() {
      console.log("refreshed");
    }
  },

  computed: {
    ...mapGetters(["currentUser"]),
    // checks if test is ongoing
    isOngoing() {
      return (
        moment(new Date(this.test.start_datetime * 1000)).isBefore(
          moment(new Date())
        ) &&
        moment(new Date(this.test.end_datetime * 1000)).isAfter(
          moment(new Date())
        )
      );
    },
    // checks if this.test is upcoming
    isUpcoming() {
      return moment(new Date(this.test.start_datetime * 1000)).isAfter(
        moment(new Date())
      );
    },
    startDateTime: function () {
      var d = new Date(this.test.start_datetime * 1000);
      return moment(d).format("D MMM h:mma YYYY");
    },
    endDateTime: function () {
      var d = new Date(this.test.end_datetime * 1000);
      return moment(d).format("D MMM h:mma YYYY");
    },
  },
};
</script>

<style scoped>
</style>